export enum DmdpErrorCodeType {
  DMDP_BAD_ARGUMENT = 'DMDP_BAD_ARGUMENT',
  DMDP_RESOURCE_NOT_FOUND = 'DMDP_RESOURCE_NOT_FOUND',
  DMDP_AUTHORIZATION_FAILED = 'DMDP_AUTHORIZATION_FAILED',
  DMDP_CONFLICT = 'DMDP_CONFLICT',
  DMDP_CONFLICT_ECODE = 'DMDP_CONFLICT_ECODE',
  DMDP_CONFLICT_UNIQUE_TAXON_NAME = 'DMDP_CONFLICT_UNIQUE_TAXON_NAME',
  DMDP_CONFLICT_OPTIMISTIC_LOCKING = 'DMDP_CONFLICT_OPTIMISTIC_LOCKING',
}
